module.exports = __webpack_public_path__ + "img/slider-arr-w-left.25495f9f.svg";